import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { ContentBlock, ModalContentBlock, PageHeader } from './components';
import ModalRoute from '../common/components/ModalRoute';
import LoginFormContainer from '../auth/components/LoginFormContainer';
import ForgotPasswordFormContainer from '../user/components/ForgotPasswordFormContainer';
import colorThemes from '../../ui/colorThemes';
import Button from '../../ui/button/Button';
import {Localize} from '../../locale/localization';

const StyledPage = styled.div`
	> header {
		text-align: center;
    margin-top: 3rem;
    margin-bottom: 10rem;
	}

	form {
		max-width: 370px;
		margin: 0 auto;
	}
`;

class LoginPage extends Component {
	
	onClick = () => {
		const { history } = this.props;
		history.replace('/');
	}

	render() {

		return (
			<div>
				<ContentBlock theme={colorThemes.TRANSPARENT}>
					<StyledPage>
						<PageHeader title={Localize("login.header")} />
						<LoginFormContainer/>
					</StyledPage>
				</ContentBlock>
				<ModalRoute exact path="/resetPassword" parentPath="/">
					<ForgotPasswordFormContainer cancelPath="/" />
				</ModalRoute>
				<ModalRoute exact path="/unauthorized" parentPath="/">
					<ModalContentBlock title="Virhe">
						<p>Kirjaudu uudelleen.</p>
						<Button onClick={this.onClick}>Sulje</Button>
					</ModalContentBlock>
				</ModalRoute>
			</div>
		);
	}
}

export default withRouter(LoginPage);


// WEBPACK FOOTER //
// ./src/modules/pages/LoginPage.js